export function isActiveParticipantsFilterTabSelected(filterParams) {
    return !!filterParams?.active;
}
